import React, { useState, useEffect } from "react";
import ImageWithBasePath from "../../../core/common/imageWithBasePath";
import DateRangePicker from "react-bootstrap-daterangepicker";
import Chart from "react-apexcharts";
import { Link } from "react-router-dom";
import { all_routes } from "../../router/all_routes";
import CollapseHeader from "../../../core/common/collapse-header";
import { getTypePipeline, opporByStage, opporByYear, opporRecent } from "../dashboardAPI";
import { ApexOptions } from "apexcharts";
interface ChartOptions {
  series: number[];
  options: ApexOptions;
}
interface Progress {
  open: number;
  win: number;
  lose: number;
}
const route = all_routes;
const DealsDashboard = () => {
  const [chartOptions3, setChartOptions3] = useState<ChartOptions>({
    series: [44, 55, 13, 43],
    options: {
      chart: {
        width: 400,
        height: 300,
        type: "pie",
      },
      legend: {
        position: "bottom",
      },
      labels: [],
      responsive: [
        {
          breakpoint: 480,
          options: {
            chart: {
              width: 275,
            },
            legend: {
              position: "bottom",
            },
          },
        },
      ],
    },
  });

  const [selectedPeriodPie, setSelectedPeriodPie] = useState<number>(30);

  const fetchPieData = async (selectedPeriodPie: number) => {
    try {
      const opporsResponse = await opporByStage(selectedPeriodPie);
      const typeResponse = await getTypePipeline("OPPORTUNITY");
      const opporsData: number[] = opporsResponse.data.data;
      const labelObjects: string[] = typeResponse.data.data;

      const labels = labelObjects
        .map((item: any) => item.name);

      setChartOptions3((prevOptions) => ({
        ...prevOptions,
        series: opporsData,
        options: {
          ...prevOptions.options,
          labels: labels,
        },
      }));
    } catch (error) {
      console.error("err", error);
    }
  };

  const [chartOptionsRecent, setChartOptionsRecent] = useState<ApexOptions>({
    chart: {
      height: 300,
      type: "area",
      zoom: { enabled: false },
    },
    colors: ["#4A00E5", "#00C49F", "#FF4560"],
    dataLabels: { enabled: false },
    xaxis: {
      categories: [
        "Jan", "Feb", "Mar", "Apr", "May", "Jun",
        "Jul", "Aug", "Sep", "Oct", "Nov", "Dec",
      ],
    },
    yaxis: {
      min: 0,
      tickAmount: 5,
    },
    legend: {
      position: "top",
      horizontalAlign: "left",
    },
  });

  const [chartSeriesRecent, setChartSeriesRecent] = useState<ApexAxisChartSeries>([]);

  useEffect(() => {
    const fetchOpporRecent = async () => {
      try {
        const response = await opporRecent();
        const rawData = response.data.data;

        const openData = rawData.map((item: any) => item.open);
        const winData = rawData.map((item: any) => item.win);
        const loseData = rawData.map((item: any) => item.lose);

        const allValues = [...openData, ...winData, ...loseData];
        const maxValue = Math.max(...allValues);
        const roundedMax = Math.ceil(maxValue / 10) * 10;

        setChartSeriesRecent([
          { name: "Open", data: openData },
          { name: "Win", data: winData },
          { name: "Lose", data: loseData },
        ]);

        setChartOptionsRecent((prev) => ({
          ...prev,
          yaxis: {
            ...prev.yaxis,
            max: roundedMax || 10,
          },
        }));
      } catch (error) {
        console.error("Error fetching recent opportunities:", error);
      }
    };

    fetchOpporRecent();
  }, []);

  useEffect(() => {
    fetchPieData(selectedPeriodPie);
  }, [selectedPeriodPie]);

  const [chartSeries, setChartSeries] = useState<any[]>([]);
  const [chartOptions4, setChartOptions4] = useState<ApexOptions>({
    chart: {
      height: 300,
      type: "area",
      zoom: {
        enabled: false,
      },
    },
    colors: ["#4A00E5"],
    dataLabels: {
      enabled: false,
    },
    title: {
      text: "",
      align: "left",
    },
    xaxis: {
      categories: [
        "Jan", "Feb", "Mar", "Apr", "May", "Jun",
        "Jul", "Aug", "Sep", "Oct", "Nov", "Dec",
      ],
    },
    yaxis: {
      min: 0,
      max: 60,
      tickAmount: 5,
    },
    legend: {
      position: "top",
      horizontalAlign: "left",
    },
  });

  useEffect(() => {
    const fetchOpporByYear = async () => {
      try {
        const response = await opporByYear();
        const data: number[] = response.data.data;

        const maxValue = Math.max(...data);
        const roundedMax = Math.ceil(maxValue / 100) * 100;

        setChartSeries([
          {
            name: "Opportunities",
            data: data,
          },
        ]);

        setChartOptions4((prevOptions) => ({
          ...prevOptions,
          yaxis: {
            ...prevOptions.yaxis,
            max: roundedMax,
          },
        }));
      } catch (error) {
        console.error("Failed to fetch oppors by year:", error);
      }
    };

    fetchOpporByYear();
  }, []);

  return (
    <div>
      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content">
          <div className="row">
            <div className="col-md-12">
              <div className="page-header">
                <div className="row align-items-center ">
                  <div className="col-md-4">
                    <h3 className="page-title">Opportunities Dashboard</h3>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <div className="card w-100">
                <div className="card-header border-0 pb-0">
                  <div className="d-flex align-items-center justify-content-between flex-wrap row-gap-3">
                    <h4>
                      <i className="ti ti-grip-vertical me-1" />
                      Opportunities By Stage
                    </h4>
                    <div className="dropdown">
                      <Link
                        className="dropdown-toggle"
                        data-bs-toggle="dropdown"
                        to="#"
                      >
                        Last {selectedPeriodPie} Days
                      </Link>
                      <div className="dropdown-menu dropdown-menu-end">
                        <Link
                          to="#"
                          className="dropdown-item"
                          onClick={() => setSelectedPeriodPie(30)}
                        >
                          Last 30 Days
                        </Link>
                        <Link
                          to="#"
                          className="dropdown-item"
                          onClick={() => setSelectedPeriodPie(15)}
                        >
                          Last 15 Days
                        </Link>
                        <Link
                          to="#"
                          className="dropdown-item"
                          onClick={() => setSelectedPeriodPie(7)}
                        >
                          Last 7 Days
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="card-body">
                  <div id="opporpiechart">
                    <Chart
                      options={chartOptions3.options}
                      series={chartOptions3.series}
                      type="pie"
                      width={chartOptions3.options?.chart?.width}
                      height={chartOptions3.options?.chart?.height}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12">
                <div className="card w-100">
                  <div className="card-header border-0 pb-0">
                    <div className="d-flex align-items-center justify-content-between flex-wrap row-gap-3">
                      <h4>
                        <i className="ti ti-grip-vertical me-1" />
                        Opportunities By Year
                      </h4>
                    </div>
                  </div>
                  <div className="card-body">
                    <div id="contact-report">
                      <Chart
                        options={chartOptions4}
                        series={chartSeries}
                        type="area"
                        height={chartOptions4.chart?.height ?? 300}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12">
                <div className="card w-100">
                  <div className="card-header border-0 pb-0">
                    <div className="d-flex align-items-center justify-content-between flex-wrap row-gap-3">
                      <h4>
                        <i className="ti ti-grip-vertical me-1" />
                        Opportunities By Status
                      </h4>
                    </div>
                  </div>
                  <div className="card-body">
                    <div id="contact-report">
                      <Chart
                        options={chartOptionsRecent}
                        series={chartSeriesRecent}
                        type="area"
                        height={chartOptionsRecent.chart?.height ?? 300}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DealsDashboard;
